module.exports = __webpack_public_path__ + "img/computer.d8ea1b97.svg";